export default __webpack_public_path__ + "static/media/roboto-v20-latin-300.8d38ed81.eot";